import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { trackEvent } from '../utils/analytics';
import './MobileGames.css';

const MobileGames = () => {
  const mobileGames = [
    {
      id: 'puzzle-pack-mobile',
      name: 'IdeaPetal Puzzle Pack',
      description: 'A future mobile bundle for Snake Garden, Memory Bloom, and Petal 2048 with rewarded-ad friendly loops.',
      icon: 'IP',
      platform: 'Android & iOS planned',
      comingSoon: true,
    },
  ];

  return (
    <>
      <SEO
        title="Mobile Games"
        description="Discover IdeaPetal mobile game plans and upcoming Android and iOS puzzle releases."
        keywords="mobile games, iOS games, Android games, download games, IdeaPetal mobile"
      />
      <div className="mobile-games-page">
        <div className="mobile-games-header">
          <div className="container">
            <h1>Mobile Games</h1>
            <p>Our mobile releases are planned after the web games prove their strongest replay loops.</p>
          </div>
        </div>

        <div className="mobile-games-content">
          <div className="container">
            <div className="mobile-games-grid">
              {mobileGames.map((game) => (
                <div key={game.id} className="mobile-game-card">
                  <div className="game-icon">{game.icon}</div>
                  <div className="game-details">
                    <h3>{game.name}</h3>
                    <p className="platform-badge">{game.platform}</p>
                    <p className="game-description">{game.description}</p>
                    {game.comingSoon ? (
                      <button className="download-button coming-soon" disabled>
                        Coming Soon
                      </button>
                    ) : (
                      <a
                        href={game.downloadLink}
                        className="download-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() =>
                          trackEvent('mobile_store_click', {
                            game_id: game.id,
                            game_name: game.name,
                            platform: game.platform,
                          })
                        }
                      >
                        Download Now
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="mobile-games-info">
              <section className="info-section">
                <h2>Why Mobile Comes Next</h2>
                <div className="features-list">
                  <div className="feature-item">
                    <span className="feature-icon">QA</span>
                    <div>
                      <h4>Proven Gameplay</h4>
                      <p>Web traffic helps identify which games deserve native mobile polish first.</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">Free</span>
                    <div>
                      <h4>Free to Play</h4>
                      <p>Mobile versions can stay free with optional rewarded ads and remove-ads purchases.</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">Apps</span>
                    <div>
                      <h4>Store Ready</h4>
                      <p>The site keeps legal pages and support links ready for future store listings.</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">New</span>
                    <div>
                      <h4>Regular Updates</h4>
                      <p>New web games can become candidates for the mobile release pipeline.</p>
                    </div>
                  </div>
                </div>
              </section>

              <section className="info-section">
                <h2>Legal Information</h2>
                <p>
                  Before downloading and playing future mobile games, please review our{' '}
                  <Link to="/mobile-games-terms">Mobile Games Terms & Conditions</Link> and{' '}
                  <Link to="/privacy">Privacy Policy</Link>.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileGames;
